import React from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Stack,
  Typography
} from "@mui/material";
import { motion } from "framer-motion";

// ICONS
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import WorkIcon from "@mui/icons-material/Work";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import TimelineIcon from "@mui/icons-material/Timeline";
import ContactMailIcon from "@mui/icons-material/ContactMail";

const CrownIcon = () => (
  <motion.svg
    initial={{ scale: 0 }}
    animate={{ scale: 1 }}
    transition={{ duration: 0.6 }}
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="#f4b400"
  >
    <path d="M5 16L3 6L8 10L12 4L16 10L21 6L19 16H5Z" />
    <rect x="5" y="16" width="14" height="2" />
  </motion.svg>
);

const Navbar = () => {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const menuItems = [
    { label: "Home", id: "home", icon: <HomeIcon fontSize="small" /> },
    { label: "About", id: "about", icon: <InfoIcon fontSize="small" /> },
    { label: "Services", id: "services", icon: <BusinessCenterIcon fontSize="small" /> },
    { label: "Experience", id: "experience", icon: <TimelineIcon fontSize="small" /> },
    { label: "Projects", id: "projects", icon: <WorkIcon fontSize="small" /> },
    { label: "Contact", id: "contact", icon: <ContactMailIcon fontSize="small" /> },
  ];

  return (
    <>
      {/* ================= DESKTOP NAVBAR ================= */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: "#ffffff",
          color: "#000000",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          
          {/* LOGO */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CrownIcon />
            <Typography
              sx={{
                ml: 1,
                fontWeight: 700,
                fontSize: "16px",
                color: "#000",
              }}
            >
              Ali Gharib
            </Typography>
          </Box>

          {/* MENU */}
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            {menuItems.map((item) => (
              <Button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                sx={{
                  color: "#000",
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: 2,
                  px: 2,

                  "&:hover": {
                    backgroundColor: "#eeeeee",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Stack>
        </Toolbar>
      </AppBar>

      {/* ================= MOBILE NAV ================= */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#ffffff",
          borderTop: "1px solid #e0e0e0",
          justifyContent: "space-between",
          px: 1,
          py: 1,
          zIndex: 999,
        }}
      >
        {menuItems.map((item) => (
          <Button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              gap: 0.3,
              color: "#000",
              textTransform: "none",
            }}
          >
            {item.icon}
            <Typography sx={{ fontSize: "10px", color: "#000" }}>
              {item.label}
            </Typography>
          </Button>
        ))}
      </Box>
    </>
  );
};

export default Navbar;